const forms = {
  state: {
    skillsList: null,
    skillsListCounter: null,
    competenciesList: null,
    competenciesCounter: null,
    certificatesList: null,
    certificatesListCounter: null,
    licencesList: null,
    licencesListCounter: null,
    resourcesList: null,
    resourcesListCounter: null
  },
  mutations: {
    changeSkillsList(state, payload) {
      state.skillsList = payload;
    },
    changeSkillsListCounter(state, payload) {
      state.skillsListCounter = payload;
    },
    changeCompetenciesList(state, payload) {
      state.competenciesList = payload;
    },
    changeCompetenciesListCounter(state, payload) {
      state.competenciesListCounter = payload;
    },
    changeCertificatesList(state, payload) {
      state.certificatesList = payload;
    },
    changeCertificatesListCounter(state, payload) {
      state.certificatesListCounter = payload;
    },
    changeLicencesList(state, payload) {
      state.licencesList = payload;
    },
    changeLicencesListCounter(state, payload) {
      state.licencesListCounter = payload;
    },
    changeResourcesList(state, payload) {
      state.resourcesList = payload;
    },
    changeResourcesListCounter(state, payload) {
      state.resourcesListCounter = payload;
    }
  },
  actions: {
    changeSkillsList({ commit }, payload) {
      commit("changeSkillsList", payload);
    },
    changeSkillsListCounter({ commit }, payload) {
      commit("changeSkillsListCounter", payload);
    },
    changeCompetenciesList({ commit }, payload) {
      commit("changeCompetenciesList", payload);
    },
    changeCompetenciesListCounter({ commit }, payload) {
      commit("changeCompetenciesListCounter", payload);
    },
    changeCertificatesList({ commit }, payload) {
      commit("changeCertificatesList", payload);
    },
    changeCertificatesListCounter({ commit }, payload) {
      commit("changeCertificatesListCounter", payload);
    },
    changeLicencesList({ commit }, payload) {
      commit("changeLicencesList", payload);
    },
    changeLicencesListCounter({ commit }, payload) {
      commit("changeLicencesListCounter", payload);
    },
    changeResourcesList({ commit }, payload) {
      commit("changeResourcesList", payload);
    },
    changeResourcesListCounter({ commit }, payload) {
      commit("changeResourcesListCounter", payload);
    }
  },
  getters: {
    getSkillsList: state => {
      return state.skillsList;
    },
    getSkillsListCounter: state => {
      return state.skillsListCounter;
    },
    getCompetenciesList: state => {
      return state.competenciesList;
    },
    getCompetenciesListCounter: state => {
      return state.competenciesListCounter;
    },
    getCertificatesList: state => {
      return state.certificatesList;
    },
    getCertificatesListCounter: state => {
      return state.certificatesListCounter;
    },
    getLicencesList: state => {
      return state.licencesList;
    },
    getLicencesListCounter: state => {
      return state.licencesListCounter;
    },
    getResourcesList: state => {
      return state.resourcesList;
    },
    getResourcesListCounter: state => {
      return state.resourcesListCounter;
    }
  }
};
// eslint-disable-next-line
export default forms;
